import cn from 'classnames';

import { colors } from '../../colors';
import { Box, BoxProps } from '../Layout';

import { skeleton } from './Skeleton.css';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
    shade: keyof typeof colors.bluegray;
};

export const Skeleton = ({ className, shade = 800, style, ...props }: SkeletonProps & BoxProps) => {
    return <Box className={cn(skeleton, className)} style={{ color: colors.bluegray[shade], ...style }} {...props} />;
};
